import React from 'react';
import { useDecision, getForegroundColor, createIconComponentFromSimpleIconsSvgPath, useIntegration } from '@consent-manager/core';
import { siMatomo } from 'simple-icons';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var _excluded = ["enabledByDefault"];
var wasInitialized = false;
var trackPageViewSPA = function trackPageViewSPA(_ref) {
  var location = _ref.location,
    prevLocation = _ref.prevLocation,
    _ref$enableLinkTracki = _ref.enableLinkTracking,
    enableLinkTracking = _ref$enableLinkTracki === void 0 ? true : _ref$enableLinkTracki,
    _ref$enableHeartBeatT = _ref.enableHeartBeatTimer,
    enableHeartBeatTimer = _ref$enableHeartBeatT === void 0 ? true : _ref$enableHeartBeatT,
    _ref$enableJSErrorTra = _ref.enableJSErrorTracking,
    enableJSErrorTracking = _ref$enableJSErrorTra === void 0 ? true : _ref$enableJSErrorTra,
    _ref$push = _ref.push,
    push = _ref$push === void 0 ? [] : _ref$push;
  var paq = window._paq;
  if (!paq) {
    return null;
  }
  var url = location && location.pathname + location.search + location.hash;
  var prevUrl = prevLocation && prevLocation.pathname + prevLocation.search + prevLocation.hash;
  var _document = document,
    title = _document.title;
  prevUrl && paq.push(['setReferrerUrl', prevUrl]);
  paq.push(['setCustomUrl', url]);
  paq.push(['setDocumentTitle', title]);
  paq.push(['trackPageView']);
  enableLinkTracking && paq.push(['enableLinkTracking']);
  enableHeartBeatTimer && paq.push(['enableHeartBeatTimer']);
  enableJSErrorTracking && paq.push(['enableJSErrorTracking']);
  paq.push(['trackAllContentImpressions']);
  if (push.length) {
    for (var _iterator = _createForOfIteratorHelperLoose(push), _step; !(_step = _iterator()).done;) {
      var pushValue = _step.value;
      paq.push(pushValue);
    }
  }
  return {
    url: url,
    title: title
  };
};
var getMatomoTracker = function getMatomoTracker() {
  return {
    trackEvent: function trackEvent() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return window._paq && window._paq.push(['trackEvent'].concat(args));
    },
    trackPageView: function trackPageView() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return window._paq && window._paq.push(['trackPageView'].concat(args));
    },
    track: function track() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      return window._paq && window._paq.push([].concat(args));
    },
    // @todo consider if we should have only the SPA track function and a regular track call
    // - because we need to track on initial embedding of the script
    trackPageViewSPA: trackPageViewSPA
  };
};
var useMatomoTracker = function useMatomoTracker(_ref2) {
  var matomoURL = _ref2.matomoURL,
    siteID = _ref2.siteID,
    _ref2$enableLinkTrack = _ref2.enableLinkTracking,
    enableLinkTracking = _ref2$enableLinkTrack === void 0 ? true : _ref2$enableLinkTrack,
    _ref2$enableHeartBeat = _ref2.enableHeartBeatTimer,
    enableHeartBeatTimer = _ref2$enableHeartBeat === void 0 ? true : _ref2$enableHeartBeat,
    _ref2$enableJSErrorTr = _ref2.enableJSErrorTracking,
    enableJSErrorTracking = _ref2$enableJSErrorTr === void 0 ? true : _ref2$enableJSErrorTr,
    _ref2$push = _ref2.push,
    push = _ref2$push === void 0 ? [] : _ref2$push;
  var _useDecision = useDecision('matomo'),
    isEnabled = _useDecision[0];
  if (!wasInitialized && isEnabled) {
    var _paq = window._paq = window._paq || [];
    enableLinkTracking && _paq.push(['enableLinkTracking']);
    enableHeartBeatTimer && _paq.push(['enableHeartBeatTimer']);
    enableJSErrorTracking && _paq.push(['enableJSErrorTracking']);
    _paq.push(['setTrackerUrl', matomoURL + "matomo.php"]);
    _paq.push(['setSiteId', siteID]);
    if (push.length) {
      for (var _iterator2 = _createForOfIteratorHelperLoose(push), _step2; !(_step2 = _iterator2()).done;) {
        var pushValue = _step2.value;
        _paq.push(pushValue);
      }
    }
    var script = document.createElement('script');
    script.src = matomoURL + "matomo.js";
    script.async = true;
    document.body.appendChild(script);
    wasInitialized = true;
    // Track current page
    var _window = window,
      location = _window.location;
    trackPageViewSPA({
      location: location
    });
  }
  var tracker = React.useMemo(function () {
    return getMatomoTracker();
  }, []);
  return tracker;
};
var WrapperComponent = function WrapperComponent() {
  var MatomoConfig = useIntegration('matomo');
  if (!MatomoConfig || !MatomoConfig.options) {
    throw new Error('It is not possible to initialize Matomo without configuration');
  }
  useMatomoTracker(MatomoConfig.options);
  return null;
};
function matomoIntegration(_ref3) {
  var matomoURL = _ref3.matomoURL,
    siteID = _ref3.siteID;
  var title = siMatomo.title,
    slug = siMatomo.slug,
    hex = siMatomo.hex,
    path = siMatomo.path;
  var color = "#" + hex;
  var contrastColor = getForegroundColor(color);
  var Icon = createIconComponentFromSimpleIconsSvgPath(title, path);
  return {
    id: slug,
    title: title,
    category: 'Statistics',
    color: color,
    contrastColor: contrastColor,
    Icon: Icon,
    privacyPolicyUrl: "https://matomo.org/privacy-policy/",
    description: 'Matomo is the leading open-source web analytics platform, used on over 1 million websites in over 190 countries, and translated into over 50 languages. Matomo is the ethical choice for those who value privacy and 100% data ownership.',
    WrapperComponent: WrapperComponent,
    options: {
      matomoURL: matomoURL,
      siteID: siteID
    }
  };
}
function matomoPrivacyAwareIntegration(_ref4) {
  var _ref4$enabledByDefaul = _ref4.enabledByDefault,
    enabledByDefault = _ref4$enabledByDefaul === void 0 ? true : _ref4$enabledByDefaul,
    config = _objectWithoutPropertiesLoose(_ref4, _excluded);
  return _extends({}, matomoIntegration(config), {
    enabledByDefault: enabledByDefault,
    category: "Fair Statistics",
    description: "Our privacy-aware statistics tool will not track you across websites or multiple days. No personal data is collected, while all other data is strongly anonymized. You can opt-out at any time."
  });
}

export { getMatomoTracker, matomoIntegration, matomoPrivacyAwareIntegration, useMatomoTracker };
//# sourceMappingURL=integration-matomo.esm.js.map
